import React from 'react';
import { Accordion } from '@lendi-ui/accordion';

import { StorageKey, useAccordionState } from '@funnels/hooks';
import { useAnalytics } from '@funnels/providers';

import { CategoryAccordionContentWrapper } from './index.style';

interface CategoryAccordionProps {
  title: string;
  dataComponent?: string;
  initialOpenState?: boolean;
  storageKey: StorageKey;
  headerClassName?: string;
}

export const CategoryAccordion: React.FunctionComponent<CategoryAccordionProps> = (props) => {
  const { storageKey, title, dataComponent, children, initialOpenState, headerClassName } = props;
  const { tracking } = useAnalytics();

  const [accordionState, setAccordionState] = useAccordionState(
    storageKey,
    initialOpenState ? { isOpen: initialOpenState } : null
  );
  const isOpen = accordionState.isOpen;

  const toggleAccordionOpenState = () => {
    setAccordionState({ ...accordionState, isOpen: !isOpen });
    if (!isOpen) {
      tracking?.accordion.expanded({
        name: title,
        position: title,
      });
    } else {
      tracking?.accordion.collapsed({ name: title, position: title });
    }
  };
  return (
    <Accordion data-component={dataComponent} isOpen={isOpen}>
      <Accordion.Header className={headerClassName} onClick={toggleAccordionOpenState}>
        {title}
      </Accordion.Header>
      <Accordion.Content>
        <CategoryAccordionContentWrapper>{children}</CategoryAccordionContentWrapper>
      </Accordion.Content>
    </Accordion>
  );
};
